import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LoaderService } from "../../../core/services/loader.service";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { ProductionWorkflowReassignLogDto } from "../../../core/models/project-workflow/productionWorkflowReassignLogDto";
import { DialogModule } from "primeng/dialog";
import { CommonModule } from "@angular/common";

@Component({
  selector: "jni-workflow-logs",
  templateUrl: "./workflow-logs.component.html",
  styleUrls: ["./workflow-logs.component.scss"],
  imports: [DialogModule, CommonModule],
})
export class WorkflowLogsComponent implements OnInit {
  @Input() workflowLogsModal = false;
  @Input() workflowId!: number;
  @Output() closeWorkflowLogsModalEvent = new EventEmitter();
  @Output() openWorkflowLogsModalEvent = new EventEmitter<string>();

  logs!: ProductionWorkflowReassignLogDto[];

  constructor(
    private _loaderService: LoaderService,
    private _workflowService: ProjectWorkflowService
  ) {}

  ngOnInit(): void {
    this.getReassignedWorkflowLogs();
  }

  closeWorkflowLogsModal() {
    this.closeWorkflowLogsModalEvent.emit();
  }

  openLogsScreen() {
    this.openWorkflowLogsModalEvent.emit();
    this.getReassignedWorkflowLogs();
  }

  getReassignedWorkflowLogs() {
    this._loaderService.setLoaderState(true);
    this._workflowService.getReassignedWorkflowLogs(this.workflowId).subscribe({
      next: res => {
        if (res?.status === "Success" && res?.data) {
          this.logs = res.data;
        }
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }
}
